import AreaTipoDivergenciaEnum from '../../AreaTipoDivergenciaEnum';
import { useBuildFinalStepTemplate } from '../../template/FinalStepTemplate';
import useBuildSubmitHandler from '../../template/UseBuildSubmitHandler';
import TipoDivergenciasKey from '../../TipoDivergenciasKey';
import { TipoDivergenciaComponent } from '../../TiposDeDivergencias';


const BordadoSemProcesso: TipoDivergenciaComponent = ({
  onBack,
  onSetStep,
}) => {


  const key = TipoDivergenciasKey.BORDADO_SEM_PROCESSO;
  const {
    loadingSave,
    loadingTipoDivergencia,
    handleSubmit,
  } = useBuildSubmitHandler(key, onSetStep);


  return useBuildFinalStepTemplate({

    area: AreaTipoDivergenciaEnum.BORDADO,
    loading: loadingSave || loadingTipoDivergencia,
    onBack,
    onSetStep: handleSubmit,
    tipoDivergencia: 'Itens que necessitam de bordado sem o processo realizado, ou não conforme.',
  });

};

export default BordadoSemProcesso;
